import React from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';
import { Button } from '@vimeo/iris/components';
import { Header, Paragraph } from '@vimeo/iris/typography';

import {
  ClipDetailsWrapper,
  ClipThumbnail,
  Header6Wrapper,
  ManageClips,
  NotificationContainer,
  NotificationHeader,
} from './styles';

export interface Clip {
  clipId: number;
  name: string;
  thumbnail: string;
  dimension: string;
  codec: string;
  quality: string;
}

export interface Props {
  clip: Clip;
}

const stripRpadFromUrl = (url: string) => url.split('?r=pad').shift();

const T = {
  ManageClips: translate('Manage Clips'),
  Confirmed: translate('Confirmed!'),
};

/**
 * Notification component which can be displyed when a clip gets added to an account.
 * @param clip - clip object being added
 */
export const Notification: React.FC<Props> = ({ clip }) => {
  return (
    <NotificationContainer>
      <NotificationHeader>
        <Header size="5">{T.Confirmed}</Header>
      </NotificationHeader>
      <ClipDetailsWrapper>
        <ClipThumbnail thumbnailUrl={stripRpadFromUrl(clip.thumbnail) || ''} />
        <Header6Wrapper>
          <Header size="6">{clip.name}</Header>
          <Paragraph size="2" format="alternative">{`(${clip.dimension} ${clip.codec})`}</Paragraph>
        </Header6Wrapper>
      </ClipDetailsWrapper>
      <ManageClips>
        <a
          target="_blank"
          href="/manage/videos"
          onClick={() => {
            FA.trackClick({
              container: 'stock_creator_albums',
              component: 'confirmation',
              keyword: 'manage_clips',
            });
          }}
        >
          <Button element="span" size="sm">
            {T.ManageClips}
          </Button>
        </a>
      </ManageClips>
    </NotificationContainer>
  );
};
